import { render, staticRenderFns } from "./DepartmentIndexView.vue?vue&type=template&id=0b64ffb9"
import script from "./DepartmentIndexView.vue?vue&type=script&lang=js"
export * from "./DepartmentIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports